import { CommonResponse, VendorBanksModelDto, VendorBanksModelDtoReq, VendorBanksResponseModel, } from "@gtpl/shared-models/masters";
import connection from "./connection";
import axios from "axios";

export class bankNamesServices{
  
    URL = connection.DEPLOY_URL + '/vendor-banks';

    async UploadExcel(req:VendorBanksModelDtoReq): Promise<VendorBanksResponseModel> {
        return await axios.post(this.URL + '/bankNamesService',req)
            .then(res => {
                return res.data
            })
    }

    async getBankNames(): Promise<VendorBanksResponseModel> {
        return await axios.post(this.URL + "/getBankNames")
        .then(res => {
            return res.data
          })
    }
}